import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VexRoutes } from 'src/@vex/interfaces/vex-route.interface';
import { TrackVehicleComponent } from './track-vehicle.component';

const routes: VexRoutes = [
  {
    path: '',
    component: TrackVehicleComponent,
    data: {
      toolbarShadowEnabled: false
    }
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrackVehicleRoutingModule { }
